import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "relative mt-2 rounded-md shadow-sm" }
const _hoisted_2 = { class: "text-sm font-semibold capitalize text-slate-900" }
const _hoisted_3 = ["required"]
const _hoisted_4 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label.replace(/_/g, " ")) + " " + _toDisplayString(_ctx.required ? "*" : ""), 1),
    _createElementVNode("input", {
      type: "file",
      accept: "image/*",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args))),
      class: "block w-full text-sm text-gray-900 border border-gray-300 rounded-lg cursor-pointer bg-gray-50 focus:outline-none",
      required: _ctx.required
    }, null, 40, _hoisted_3),
    (_ctx.imageUrl)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _ctx.imageUrl,
            alt: "Image preview",
            class: "rounded-md shadow-lg w-32 h-32 object-cover"
          }, null, 8, _hoisted_5)
        ]))
      : _createCommentVNode("", true)
  ]))
}